import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import LazyImage from "../../shared/lazyImage";
import { Link } from "react-router-dom";

const Categories = ({ categories }) => {
  return (
    <div className="feature" id="featureSection">
      <div className="container container-lg">
        <div className="position-relative arrow-center gradient-shadow">
          <div className="flex-align">
            <button
              type="button"
              id="categories-prev"
              className="slick-prev flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1 slick-arrow"
            >
              <i className="ph ph-caret-left" />
            </button>
            <button
              type="button"
              id="categories-next"
              className="slick-next flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1 slick-arrow"
            >
              <i className="ph ph-caret-right" />
            </button>
          </div>
          <Swiper
            modules={[Navigation]}
            slidesPerView={5}
            spaceBetween={20}
            loop={true}
            navigation={{
              prevEl: "#categories-prev",
              nextEl: "#categories-next",
            }}
            breakpoints={{
              320: { slidesPerView: 2.5 },
              768: { slidesPerView: 4 },
              1024: { slidesPerView: 5 },
              1200: { slidesPerView: 7 },
            }}
            className="feature-item-wrapper"
          >
            {categories?.map((category, index) => (
              <SwiperSlide key={index}>
                <div className="feature-item text-center">
                  <div className="feature-item__thumb rounded-circle">
                    <Link
                      to={`/collections/sub-category/${category?.slug}`}
                      className="w-100 h-100 flex-center category-position"
                    >
                      <LazyImage
                        src={category.category_image || category.name}
                        alt={category.name}
                      />
                    </Link>
                  </div>
                  <div className="feature-item__content mt-16">
                    <h6 className="text-lg mb-8">
                      <Link
                        to={`/collections/sub-category/${category?.slug}`}
                        className="text-inherit"
                      >
                        {category.name}
                      </Link>
                    </h6>
                    <span className="text-sm text-gray-400">
                      {category.products_count || "0"} Products
                    </span>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Categories;
